export const url = (value) =>
  value && !/(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!]))?/gm.test(value)
    ? 'Invalid URL'
    : undefined;
